<template>
    <div :class="[
        'input-text-multiple',
        { 'is-error': isError }
    ]">
        <label v-text="''" />
        <div class="flex flex-space-4">
            <input 
                v-for="(item, i) in items" 
                :key="i" 
                v-model="values[i]"
                :style="{ width: Math.round(100 / items.length) + '%' }"
                :placeholder="item"
                @input="onInput" 
                @keyup="isError = false"
            />
        </div>
    </div>
</template>

<script>
import ValidateMixin from '@/mixins/ValidateMixin'

export default {
    mixins: [
        ValidateMixin
    ],

    props: {
        items: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            values: []
        }
    },

    computed: {
        value() {
            if (this.values.length !== 2 || !this.values[0] || !this.values[1]) {
                return ''
            }

            console.log(this.values)

            if (this.values[0].length === 0 && this.values[1].length === 0) {
                return ''
            }

            return this.values.join('')
        }
    },

    methods: {
        onInput() {
            this.$emit('input', this.values)
        },

        getValidationConstraints() {
            return [
                this.validateAgainstRequired()
            ]
        }
    }
}
</script>

<style lang="scss">
.input-text-multiple {
    @include input();

    input {
        text-align: left;
        letter-spacing: 0;

        &::placeholder {
            color: $color-border-light;
        }
    }
}
</style>